export enum CurrentSpectrumTabEnum {
  Spectrum2D = "2D Spectrum",
  Spectrum3D = "3D Spectrum",
}
